import src from "IMAGE";
export default { src, width: 288, height: 182, blurWidth: 0, blurHeight: 0};
